import { STARS } from "../data/stars";

export default function StarBackground() {
  return STARS.map(star => (
    <div key={star.id} style={{
      position: "fixed",
      left: `${star.x}%`,
      top: `${star.y}%`,
      width: `${star.size}px`,
      height: `${star.size}px`,
      borderRadius: "50%",
      background: "white",
      animation: `twinkle ${star.duration}s ${star.delay}s ease-in-out infinite`,
      pointerEvents: "none",
      zIndex: 0,
    }} />
  ));
}
